// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container {
    position: fixed;
    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;
    color: var(--white);
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 3;
}

.navbar {
    display: flex;
    justify-content: space-between;
    background-color: transparent;
    padding: 0 3.75em;
    width: 100%;
    max-width: 1440px;
    max-height: 72px;
}

.navbar a {
    color: var(--white);
    transition: color 0.5s ease-in-out;
}

.navbar-container.color {
    background-color: var(--white);
    color: var(--gray-06);
    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;
}

.navbar-container.color a {
    color: var(--gray-06);
}

.menu-items {
    display: flex;
    align-items: center;
    gap: var(--3sm);
}

.menu-item {
    display: block;
    text-align: left;
    position: relative;
}

.menu-item-label {
    display: flex;
    gap: var(--4sm) * 0.5;
    align-items: center;
}

.drop-downs {
    display: flex;
    flex-direction: column;
    text-align: left;
    position: absolute;
    background-color: var(--white);
    top: 100%;
    width: 8em;
}

ul {
    padding: 0;
}

p#drop-down {
    color: var(--gray-06);
    text-align: left;
    padding:  var(--4sm) var(--3sm);
}

.nav-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 82.835px;
    height: 32.201px;
    margin-right: var(--4sm);
}
  
.nav-image-container img {
    flex-shrink: 0;
    width: 100%;
  }

button.nav-button {
    /* padding: 0.8em 0.8em; */
    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;
}

.navbar-container button.nav-button.lowContrast.home {
    background-color: transparent;
    border-color: var(--white);
    color: var(--white);
}

.navbar-container.color button.nav-button.lowContrast.home {
    background-color: transparent;
    border-color: var(--gray-06);
    color: var(--gray-06);
}

.navbar-container button.nav-button.highContrast.home {
    background-color: var(--osc-brand-color);
    border-color: var(--osc-brand-color);
    color: var(--white);
}

.navbar-container button.nav-button.lowContrast.notHome {
    background-color: transparent;
    border-color: var(--white);
    color: var(--white);
}

.navbar-container button.nav-button.highContrast.notHome {
    background-color: var(--white);
    border-color: var(--osc-brand-color);
    color: var(--osc-brand-color);
}

.navbar-container.color button.nav-button.lowContrast.notHome {
    background-color: white;
    border-color: var(--gray-06);
    color: var(--gray-06);
}

.navbar-container.color button.nav-button.highContrast.notHome {
    background-color: var(--osc-brand-color);
    color: var(--white);
}

svg#downcarrot {
    width: var(--3sm);
    height: var(--3sm);
}
  
svg.navbarHasColor {
    stroke: var(--gray-06);
    transition: stroke 0.5s ease-in-out;
}

svg.navbarTransparent {
    stroke: var(--white);
    transition: stroke 0.5s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,qEAAqE;IACrE,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;EACb;;AAEF;IACI,0BAA0B;IAC1B,qEAAqE;AACzE;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mCAAmC;AACvC","sourcesContent":[".navbar-container {\n    position: fixed;\n    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;\n    color: var(--white);\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    z-index: 3;\n}\n\n.navbar {\n    display: flex;\n    justify-content: space-between;\n    background-color: transparent;\n    padding: 0 3.75em;\n    width: 100%;\n    max-width: 1440px;\n    max-height: 72px;\n}\n\n.navbar a {\n    color: var(--white);\n    transition: color 0.5s ease-in-out;\n}\n\n.navbar-container.color {\n    background-color: var(--white);\n    color: var(--gray-06);\n    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;\n}\n\n.navbar-container.color a {\n    color: var(--gray-06);\n}\n\n.menu-items {\n    display: flex;\n    align-items: center;\n    gap: var(--3sm);\n}\n\n.menu-item {\n    display: block;\n    text-align: left;\n    position: relative;\n}\n\n.menu-item-label {\n    display: flex;\n    gap: var(--4sm) * 0.5;\n    align-items: center;\n}\n\n.drop-downs {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    position: absolute;\n    background-color: var(--white);\n    top: 100%;\n    width: 8em;\n}\n\nul {\n    padding: 0;\n}\n\np#drop-down {\n    color: var(--gray-06);\n    text-align: left;\n    padding:  var(--4sm) var(--3sm);\n}\n\n.nav-image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    width: 82.835px;\n    height: 32.201px;\n    margin-right: var(--4sm);\n}\n  \n.nav-image-container img {\n    flex-shrink: 0;\n    width: 100%;\n  }\n\nbutton.nav-button {\n    /* padding: 0.8em 0.8em; */\n    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;\n}\n\n.navbar-container button.nav-button.lowContrast.home {\n    background-color: transparent;\n    border-color: var(--white);\n    color: var(--white);\n}\n\n.navbar-container.color button.nav-button.lowContrast.home {\n    background-color: transparent;\n    border-color: var(--gray-06);\n    color: var(--gray-06);\n}\n\n.navbar-container button.nav-button.highContrast.home {\n    background-color: var(--osc-brand-color);\n    border-color: var(--osc-brand-color);\n    color: var(--white);\n}\n\n.navbar-container button.nav-button.lowContrast.notHome {\n    background-color: transparent;\n    border-color: var(--white);\n    color: var(--white);\n}\n\n.navbar-container button.nav-button.highContrast.notHome {\n    background-color: var(--white);\n    border-color: var(--osc-brand-color);\n    color: var(--osc-brand-color);\n}\n\n.navbar-container.color button.nav-button.lowContrast.notHome {\n    background-color: white;\n    border-color: var(--gray-06);\n    color: var(--gray-06);\n}\n\n.navbar-container.color button.nav-button.highContrast.notHome {\n    background-color: var(--osc-brand-color);\n    color: var(--white);\n}\n\nsvg#downcarrot {\n    width: var(--3sm);\n    height: var(--3sm);\n}\n  \nsvg.navbarHasColor {\n    stroke: var(--gray-06);\n    transition: stroke 0.5s ease-in-out;\n}\n\nsvg.navbarTransparent {\n    stroke: var(--white);\n    transition: stroke 0.5s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
